export default function Config(dataset, color) {
  const config = {
    color,
    dataset,
    tooltip: {
      show: true,
      trigger: 'axis',
      enterable: true,
      confine: true,
    },
    xAxis: {
      type: 'category',
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        align: 'center',
        margin: 10,
        padding: [0, 0, 0, 0],
        textStyle: { color: '#666995' }
      },
    },
    yAxis: {
      type: 'value',
      nameTextStyle: {
        color: 'var(--m-link-normal)',
        align: 'left',
        padding: [0, 0, 10, 0],
      },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        textStyle: { color: '#666995' }
      },
      splitLine: {
        lineStyle: {
          color: 'var(--m-fill-1)',
          type: 'solid',
          width: 1,
        }
      }
    },
    grid: {
      containLabel: true,
      top: 20,
      right: 0,
      bottom: 0,
      left: 0,
    },
    series:
      dataset.source?.[0]?.filter((_, index) => index !== 0).map((m, index) => {
        return {
          type: 'bar',
          encode: { x: 0, y: index + 1, seriesName: m, },
          // label: {
          //   show: true,
          //   position: 'top'
          // }
        }
      }) || []
  }
  return config
}
